"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var warehousesList_1 = require("common/global/warehousesList");
var js_1 = require("qrcode-generator-ts/js");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
function PrescriptionPrint(_a) {
    var _b, _c, _d, _e, _f, _g;
    var sessionId = _a.sessionId, session = _a.session, printFnRef = _a.printFnRef, type = _a.type, kind = _a.kind;
    console.log({ session: session });
    var t = (0, react_i18next_1.useTranslation)().t;
    var PresDocs = [
        {
            sessionDetails: session.non_available_prescription,
            type: "notAvailable",
        },
        { sessionDetails: session.logistics_prescription, type: "done" },
    ];
    var qr = (0, react_1.useMemo)(function () {
        var qr = new js_1.QRCode();
        qr.setTypeNumber(8);
        qr.setErrorCorrectLevel(js_1.ErrorCorrectLevel.L);
        qr.addData(new js_1.QR8BitByte(sessionId));
        qr.make();
        return qr;
    }, [sessionId]);
    var printCb = (0, react_1.useCallback)(function () {
        function printElem(elem) {
            var newWindow = window.open("", "PRINT", "height=400,width=600");
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.write("<html><head><title>" + document.title + "</title>");
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.write("</head><body >");
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.write(document.getElementById(elem).innerHTML);
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.write("</body></html>");
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.document.close(); // necessary for IE >= 10
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus(); // necessary for IE >= 10*/
            newWindow === null || newWindow === void 0 ? void 0 : newWindow.print();
            return true;
        }
        printElem(kind);
    }, [type]);
    printFnRef.current = printCb;
    var arr = {
        "1/24": "مره في اليوم",
        "1/12": "كل 12 ساعة",
        "1/8": "كل 8 ساعات",
        "1/6": "كل 6 ساعات",
        "1/5": "كل 5 ساعات",
        onNeed: "عند الحاجة",
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
            display: "".concat(type),
        } }, { children: (PresDocs[0].sessionDetails == undefined ||
            PresDocs[0].sessionDetails.length == 0) &&
            (PresDocs[1].sessionDetails == undefined ||
                PresDocs[1].sessionDetails.length == 0) ? null : ((0, jsx_runtime_1.jsxs)("div", __assign({ id: kind }, { children: [(0, jsx_runtime_1.jsx)("img", { height: 70, src: "https://vyjtlzjzvurvuwkvdhdo.supabase.co/storage/v1/object/public/publicBucket//Picture1.png" }), (0, jsx_runtime_1.jsx)("p", __assign({ style: {
                        textAlign: "center",
                        margin: 2,
                        fontWeight: "bolder",
                        fontSize: 24,
                    } }, { children: "منظمة الأطباء المستقلين" })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: (_c = (_b = warehousesList_1.globalWarehousesData[session === null || session === void 0 ? void 0 : session.center_id]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "" })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: "وصفة طبية" })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: t("common.fullDateTime", {
                        date: (_d = session === null || session === void 0 ? void 0 : session.end_date) !== null && _d !== void 0 ? _d : "",
                    }) })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: "\u0627\u0633\u0645 \u0627\u0644\u0645\u0631\u064A\u0636: ".concat(session === null || session === void 0 ? void 0 : session.cached_patient_name, " ") })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: "\u062C\u0646\u0633 \u0627\u0644\u0645\u0631\u064A\u0636: ".concat(session === null || session === void 0 ? void 0 : session.cached_sex, " ") })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: "\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u064A\u0644\u0627\u062F : ".concat(t("common.DateTime", {
                        date: (_e = session === null || session === void 0 ? void 0 : session.cached_birthdate) !== null && _e !== void 0 ? _e : "",
                    }), " ") })), (0, jsx_runtime_1.jsx)("p", __assign({ style: { textAlign: "center", margin: 2 } }, { children: "\u0627\u0633\u0645 \u0627\u0644\u0637\u0628\u064A\u0628: ".concat((_g = (_f = session === null || session === void 0 ? void 0 : session.cached_doctors_name) === null || _f === void 0 ? void 0 : _f.join(", ")) !== null && _g !== void 0 ? _g : "", " ") })), PresDocs === null || PresDocs === void 0 ? void 0 : PresDocs.map(function (pres, index) {
                    return pres.sessionDetails == undefined ||
                        pres.sessionDetails.length == 0 ? null : ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                                // position: 'absolute',
                                // zIndex: 0,
                                // background: 'white',
                                // display: 'block',
                                // minHeight: '50%',
                                // minWidth: '50%',
                                // color: 'yellow',
                                // margin: '0 auto',
                                } }, { children: (0, jsx_runtime_1.jsx)("p", __assign({ style: {
                                        textAlign: "center",
                                        // color: 'lightgrey',
                                        fontSize: "20px",
                                        // transform: 'rotate(60deg)',
                                        // WebkitTransform: 'rotate(60deg)',
                                    } }, { children: pres.type === "done"
                                        ? "الوصفة المصروفة"
                                        : "الوصفة الخارجية" })) })), (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                                    // position: 'absolute',
                                    zIndex: 1,
                                } }, { children: (0, jsx_runtime_1.jsx)("ol", __assign({ style: { textAlign: "right", direction: "rtl" } }, { children: (pres.sessionDetails || []).map(function (item, index) {
                                        return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ style: {
                                                        textAlign: "right",
                                                        direction: "rtl",
                                                        margin: 2,
                                                    } }, { children: [(0, jsx_runtime_1.jsxs)("span", { children: ["الدواء والتركيز", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.cached_product_name }), " - ", (0, jsx_runtime_1.jsx)("span", { children: item.cached_product_description }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["الشكل الدوائي", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.cached_product_unit_name }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["الجرعة", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.quantity }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["التواتر", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: arr[item === null || item === void 0 ? void 0 : item.per] }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["المدة/ايام", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.duration }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["الكمية الكلية", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item.overall_quantity }), "  __  ", (0, jsx_runtime_1.jsxs)("span", { children: ["ملاحظات ", " ", ": "] }), (0, jsx_runtime_1.jsx)("span", { children: item === null || item === void 0 ? void 0 : item.note })] })), (0, jsx_runtime_1.jsx)("hr", { style: { width: "100%" } })] }, index));
                                    }) })) })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("hr", { style: { width: "100%" } }), (0, jsx_runtime_1.jsx)("br", {})] }, index));
                }), (0, jsx_runtime_1.jsx)("img", { alt: "QR-Code", src: qr.toDataURL(), style: {
                        margin: "auto",
                        width: 150,
                        height: 150,
                        cursor: "pointer",
                    } }), (0, jsx_runtime_1.jsx)("br", {}), "يرجى التأكد من استلام جميع محتويات الوصفة المصروفة قبل مغادرة الصيدلية ومراجعة المسؤول في حال وجود اي نقص ، كما يرجى الالتزام بالجرعة والوقت المحدد لها"] }))) })));
}
exports.default = PrescriptionPrint;
